import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import { NgXCookies } from 'ngx-cookies';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../environments/environment';
import { AuthService } from './auth.service';

@Injectable()
export class GenericService {


  constructor(private _http: Http, private _authService: AuthService) {

  }

  /* Generic getResource
  * @param resourceUrl : resource name
  * @param isSecured : true if the resource needs authentication
  */
  public getResource(resource, isSecured, page): Observable<any> {
    const headers = new Headers({'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'});
    //
    if (isSecured) {
      // Add acces token to the hpageeader if the resource isSecured
      headers.append('x-access-token' , this._authService.getAccesToken());
    }
    let url = environment.apiEndpoint + resource;
    if ( page > 0 ) {
      url += '?page=' + page;
    }
    const options = new RequestOptions({ headers: headers });
    return this._http.get(url, options)
                   .map((res: Response) => res.json())
                   .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  /*
  * find resource by ID
  */

  public findById(resource, id, isSecured) {
    // # Header with acces token
    const headers = new Headers({'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'});
    if (isSecured) {
          headers.append('x-access-token' , this._authService.getAccesToken());
    }
    const options = new RequestOptions({ headers: headers });
    return this._http.get(environment.apiEndpoint + resource + '/' + id, options)
                   .map((res: Response) => res.json())
                   .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  /*
  * Save resource method : POST OR PUT
  */

  public saveResource(resource, obj, isSecured, contentType) {
    // # Header with acces token
    let body: any;
    body = obj;
    const headers = new Headers({'Content-type': contentType});
    // if the request is secured, send the access_token
    if (isSecured) {
      headers.append('x-access-token' , this._authService.getAccesToken());
    }
    let urlSearchParams = new URLSearchParams();
    if ( contentType !== 'application/json; charset=utf-8') {
      urlSearchParams = this.appendParams(urlSearchParams, obj);
      body = urlSearchParams;
    }
    const options = new RequestOptions({ headers: headers });
    let response;
    // Check if POST or PUT request
    if (obj._id != null) {
      response = this._http.put(environment.apiEndpoint + resource + '/' + obj._id, body, options);
    } else {
      response = this._http.post(environment.apiEndpoint + resource, body, options);
    }

    return response
                 .map((res: Response) => res.json())
                 .catch((error: any) => Observable.throw(error.json().error || 'Server error'));

    // return response
    //                .map((res: Response) => {
    //                  console.log("service save resource ==> ", res.json()),
    //                  res.json()})
    //                .catch((error: any) => {
    //                  console.log("Catch ERR  update ==> ", error),
    //                  Observable.throw(error.json().error || 'Server error') });
  }



  
  /*
  * POST method :
  */

 public post(resource, obj, isSecured, contentType) {
  // # Header with acces token
  let body: any;
  body = obj;
  const headers = new Headers({'Content-type': contentType});
  // if the request is secured, send the access_token
  if (isSecured) {
    headers.append('x-access-token' , this._authService.getAccesToken());
  }
  let urlSearchParams = new URLSearchParams();
  if ( contentType !== 'application/json; charset=utf-8') {
    urlSearchParams = this.appendParams(urlSearchParams, obj);
    body = urlSearchParams;
  }
  const options = new RequestOptions({ headers: headers });
  let response;

    response = this._http.post(environment.apiEndpoint + resource, body, options);

  return response
                 .map((res: Response) => res.json())
                 .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
}


/**
 * find with args : POST - passing object
 */

public searchWithBody(url, obj, isSecured, sortDir, key) {
  // # Header with acces token
  let body: any;
  body = obj;

  const headers = new Headers({'Content-type': environment.contentTypes.json});
  // if the request is secured, send the access_token
  if (isSecured) {
    headers.append('x-access-token' , this._authService.getAccesToken());
  }
  let urlSearchParams = new URLSearchParams();
  urlSearchParams = this.appendParams(urlSearchParams, obj);
  body = urlSearchParams;
  const options = new RequestOptions({ headers: headers, params :{sortDirection : sortDir, sortKey : key} } );
  let response;

  response = this._http.post(environment.apiEndpoint + url, obj, options);
  return response
                 .map((res: Response) => res.json())
                 .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
}



public searchConsultantWithBody(url, obj, isSecured, sortDir, key) {
  // # Header with acces token
  let body: any;
  body = obj;

  const headers = new Headers({'Content-type': environment.contentTypes.json});
  // if the request is secured, send the access_token
  if (isSecured) {
    headers.append('x-access-token' , this._authService.getAccesToken());
  }
  let urlSearchParams = new URLSearchParams();
  urlSearchParams = this.appendParams(urlSearchParams, obj);
  body = urlSearchParams;
  const options = new RequestOptions({ headers: headers, params :{sortDirection : sortDir, sortKey : key} } );
  let response;

  response = this._http.post(environment.apiEndpoint + url, obj, options);
  return response
                 .map((res: Response) => res.json())
                 .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
}


  /*
  * Delete resource
  */

  public deleteResource(resource, id, isSecured) {
    // # Header with acces token
    const headers = new Headers({'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'});
    if (isSecured) {
      headers.append('x-access-token' , this._authService.getAccesToken());
    }
    const options = new RequestOptions({ headers: headers });
    return this._http.delete(environment.apiEndpoint + resource + '/' + id, options)
                   .map((res: Response) => {
                     res.json()})
                   .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  // append object attribute to the urlsearch parameter
  appendParams(params: URLSearchParams, obj: any) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        params.append(key, obj[key]);
      }
    }
    return params;
  }


  // filling  pages informations from api response
  setPagesInformations(response: any ) {
    const pagesInfos: any = {};

    pagesInfos.last = response.last;
    pagesInfos.totalPages = response.totalPages;
    pagesInfos.totalElements = response.totalElements;
    pagesInfos.sort = response.sort;
    pagesInfos.numberOfElements = response.numberOfElements;
    pagesInfos.first = response.first;
    pagesInfos.number = response.number;

    return pagesInfos;
  }

  getResourceWithPassingParameter(resource, object, isSecured, contentType) {

        const params = new URLSearchParams();
        const headers = new Headers({'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'});
        if (isSecured) {
          headers.append('x-access-token' , this._authService.getAccesToken())
        }
        let urlSearchParams = new URLSearchParams();
        if ( contentType !== 'application/json; charset=utf-8') {
          urlSearchParams = this.appendParams(urlSearchParams, object);
        }
        const options = new RequestOptions({ search: urlSearchParams.toString(), headers: headers });
        return this._http.get(environment.apiEndpoint + resource, options)

        .map((res: Response) => res.json())
        .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
      }


      static downloadFileFromResponse(response: any, fileName: string) {
        const url = window.URL.createObjectURL(response);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
      }
}



// WEBPACK FOOTER //
// ./src/app/generic.service.ts